module.exports = __webpack_public_path__ + "static/media/step3@1x.ee457f7a.webm";